module.exports = __webpack_public_path__ + "static/media/duke.883c9957.png";